export enum VehicleCategories {
  Bike = 1,
  Edpm = 2,
}
